// extracted by mini-css-extract-plugin
module.exports = {"title":"AddCompanyUserModal_title__1hBVQ","divider":"AddCompanyUserModal_divider__27BcX","button":"AddCompanyUserModal_button__1H5IF","text":"AddCompanyUserModal_text__3-re-"};